(function($) {
  $(function() {
    var $slideCard = $('.slide-cards .card');

    $slideCard.addAccess();

    $slideCard.on('click.slideCard', function(e) {
      $(this).toggleClass(actClass).find('.details .desc').slideToggle('400');
    });
  });
})($JQ);
